import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Image, ThemeName } from "@evergis/ui";

import { ChatControlButtonContainer } from "./styled";

import { useChatActive } from "../../../../hooks/chat/useChatActive";
import { getThemeName } from "../../../../ducks/theme/selectors";

import senseLogo from "../../../../assets/sense_logo.gif";
import senseLogoDark from "../../../../assets/sense_logo_dark.gif";

export const ChatControlButton: FC = () => {
  const [chatActive, setChatActive] = useChatActive();
  const themeName = useSelector(getThemeName);

  return (
    <ChatControlButtonContainer onClick={() => setChatActive(!chatActive)} title="Sense">
      <Image src={themeName === ThemeName.Dark ? senseLogoDark : senseLogo} width="24px" height="24px" />
    </ChatControlButtonContainer>
  );
};
